(() => {
  const elements = document.querySelectorAll(".js-customer-count");
  if (!elements.length) return;

  // Tunables
  const BASELINE = Number(elements[0].dataset.baseline) || 210324;
  const BASELINE_YEAR = 2025;
  const BASELINE_MONTH = 8; // August (1-based)
  const AVG_PER_MONTH = 6300;
  const MIN_EXTRA = 6000;
  const MAX_EXTRA = 7000;

  // Calculate months elapsed
  const now = new Date();
  const monthsElapsed =
    (now.getFullYear() - BASELINE_YEAR) * 12 +
    (now.getMonth() + 1) - BASELINE_MONTH;

  // Deterministic pseudo-random offset
  const seed = now.getFullYear() * 100 + (now.getMonth() + 1);
  const rand = (() => {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
  })();
  const extra = Math.floor(rand * (MAX_EXTRA - MIN_EXTRA + 1)) + MIN_EXTRA;

  // Final total
  const total = BASELINE + monthsElapsed * AVG_PER_MONTH + extra;
  const formatted = total.toLocaleString("en-US");

  // Update all matching elements
  elements.forEach(el => {
    el.textContent = formatted;
  });
})();
